import { Admin, CustomRoutes, Resource } from 'react-admin'
import dataProvider from './providers/data/mfhProvider'
import MfhLayout from './layout/Layout'
import ResultList from './components/list/ResultList/ResultList'
import { Route } from 'react-router-dom'
import ProvidersList from './components/list/ProvidersList/ProvidersList'
import ResultDetail from './components/details/ResultDetail'
import Dashboard from './dashboard/Dashboard'
import { ProviderContextProvider } from './context/ProviderContext'
import authProvider from './providers/auth/authProvider'
import VerifyToken from './components/auth/VerifyToken'
import BulkOrders from './components/list/BulkOrders/BulkOrders'
import KitsAssociatedToBulkOrders from './components/list/KitsAssociatedToBulkOrders/KitsAssociatedToBulkOrders'
import BulkOrderKitsDetail from './components/details/BulkOrderKitsDetails'
import KitRequests from './components/KitRequests/KitRequests'
import KitRequestEdit from './components/KitRequests/KitRequestEdit'
import NotificationSettings from './components/NotificationSettings/NotificationSettings'

function App() {
  return (
    <ProviderContextProvider>
      <Admin
        disableTelemetry
        dashboard={Dashboard}
        layout={MfhLayout}
        loginPage={VerifyToken}
        requireAuth
        authCallbackPage
        dataProvider={dataProvider}
        authProvider={authProvider}
      >
        <CustomRoutes>
          <Route path="provider-portal/providers" element={<Resource name="provider-portal" list={ProvidersList} />} />
          <Route path="provider-portal/results/:id" element={<Resource name="provider-portal/results" list={ResultList} />} />
          <Route path="provider-portal/bulk-orders" element={<Resource name="provider-portal/bulk-orders" list={BulkOrders} />} />
          <Route path="provider-portal/bulk-orders/:orderId" element={<Resource list={KitsAssociatedToBulkOrders} />} />
          <Route path="provider-portal/bulk-orders/:orderId/kits/:kitId/show" element={<BulkOrderKitsDetail />} />
          <Route path="provider-portal/kit-requests/:id/edit" element={<KitRequestEdit />} />
          <Route path="provider-portal/kit-requests" element={<KitRequests />} />
          <Route path="provider-portal/notification-settings" element={<NotificationSettings />} />
        </CustomRoutes>
        <Resource name="provider-portal/results" list={ResultList} show={ResultDetail} />
      </Admin>
    </ProviderContextProvider>
  )
}

export default App
